import React from 'react';
import { useStyles } from '../../contexts/StyleContext';

const Card = ({ 
  children, 
  className = '', 
  ...props 
}) => {
  const styles = useStyles();
  const { card } = styles;

  const cardClasses = `
    bg-white 
    rounded-xl 
    shadow-md 
    border 
    hover:shadow-lg 
    transition-shadow 
    duration-200
    ${className}
  `.trim();

  const cardStyle = {
    borderColor: card.container.borderColor
  };

  return (
    <div 
      className={cardClasses}
      style={cardStyle}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;
